// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2188":"269d5063","2379":"50c70aad","7572":"09f6cf8b","8198":"9bb086c3","9934":"6e0f2151"}[chunkId] + ".css";
};